import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

const SEARCH_ROW_HEIGHT = 56;

export const StyledSearchContainer = styled(Flex)`
    align-items: center;
    justify-content: space-between;
    flex-grow: 1;
    gap: 8px;
`;

export const StyledSearchRow = styled(Flex)<{ $isDisabled?: boolean }>`
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    flex-shrink: 0;
    height: ${SEARCH_ROW_HEIGHT}px;

    padding-left: 16px;
    padding-right: 8px;

    background-color: ${({ $isDisabled }) =>
        $isDisabled ? colorsPalettes.bluegrey["200"] : colorsPalettes.carbon["0"]};
    cursor: ${({ $isDisabled }) => ($isDisabled ? "not-allowed" : "auto")};
`;
